import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';

@Component({
  selector: 'app-statewisestatement',
  templateUrl: './statewisestatement.component.html',
  styleUrls: ['./statewisestatement.component.scss']
})

export class StatewisestatementComponent {

   //groupedStates = [];
  //districtwiseData;
  statewiseData;
  updateStatus:any = false;
  deleteStatewiseStatemet: any = true;
  total_sub_count = 0;
  totalparcel = 0;
  totalanksankhya = 0;
  delivery_mode;
  sundayankDate;
  dispatchankDate;
  district: any;
  selectedIds: any = ""
  country;
  count;
type: any;
  state : any
  totalcount: any;
  issuedate :any;
  country_names :any;
 // updateStatus: any = false;
  data1:any
  groupedStates=[];
 // { state: string; count: any; }
 //groupedStates:{ state: string; count: any; }[];


  constructor(
    private dialogref: MatDialogRef<StatewisestatementComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService
  ) {}
  

  ngOnInit(): void {
    debugger;
  // this.districtwiseData = this.data['data'];
  this.sundayankDate = this.data['sundaydate'];
  this.dispatchankDate = this.data['dispatchdate'];
  this.type = this.data['type'];
  this.state = this.data.state;
  this.delivery_mode = this.data.delivery_mode[0];
  this.country_names = this.data.country_names;
  this.updateStatus = this.data['updateStatus'];
  this.issuedate = this.data.issuedate;
  this.data1 = this.data.data
  debugger;
console.log(this.data1,"statecount")
  const req:any = {
    "state": this.state,
    "issuedate" : this.issuedate,
    "country_names" : this.country_names,
    "type" : this.type,
    "sundaydate" : this.sundayankDate,
   
  }

  // this.service.getstatewisecount(req).subscribe((data: any) => {
  //   console.log("Get statewisedata",data)
  //     this.filtereddistrictwisesubcout = data as any;  
  //     this.totalcount = 0;
  //     for (let data1 of this.filtereddistrictwisesubcout) {
  //       debugger;
  //       this.totalcount += parseInt(data1.total_count) || 0;  
  //          }
  // });
  this.groupedStates = this.groupDataByState(this.data1);
  console.log(this.groupedStates);

 this.totalcount =0
  for (let data12 of this.groupedStates) {
    this.totalcount += parseInt(data12.count)
  }
  

  if (this.updateStatus) {
    this.total_sub_count = 0;
    this.totalparcel = 0;
    this.totalanksankhya = 0;
    let tempdata = this.uniqueid(this. statewiseData, (a) => a['district']);

    this.groupedStates = [];
    for (let index = 0; index < Object.keys(tempdata).length; index++) {
      let arr = this. statewiseData.filter(
        (a) => a['district'] == tempdata[index]['district']
      );

      let delivery_mode_unique = this.uniqueid(arr, (a) => a['delivery_mode']);
      // console.log({ delivery_mode_unique });

      let totalTapalCount = 0;
      let parcelval = 0;
      let anksankhya = 0;
      for (let j = 0; j < Object.keys(delivery_mode_unique).length; j++) {
        let arr1 = arr.filter(
          (a) => a['delivery_mode'] == delivery_mode_unique[j]['delivery_mode']
        );

        let hasteTapalJPO = [];
        if (arr1[0]['delivery_mode'] === this.type[0]) {
          totalTapalCount = Object.keys(arr1).length;
          // console.log({ totalTapalCount });
        } else if (arr1[0]['delivery_mode'] === 'हस्ते') {
          hasteTapalJPO = arr1.filter(
            (a) => a['dis_mode'] == 'टपाल' && a['dis_sub_mode'] == 'जी.पी.ओ'
          );

          if (hasteTapalJPO.length > 0) {
            let hasteTapalJPOUnique = this.uniqueid(
              hasteTapalJPO,
              (a) => a['distribution_rep']
            );
            // console.log({ hasteTapalJPOUnique });
            parcelval = hasteTapalJPOUnique.length;
            hasteTapalJPOUnique.map((tapal) => {
              let ank = hasteTapalJPO.filter(
                (a) => a['distribution_rep'] === tapal['distribution_rep']
              );
              // console.log({ ank });
              anksankhya += ank.length;
            });
          }
        }
      }

      this.groupedStates.push({
        name:tempdata[index]['name'],
        Subscription_Type: tempdata[index]['Subscription_Type'],
        address: tempdata[index]['address'],
        country: tempdata[index]['country'],
        delivery_mode: tempdata[index]['delivery_mode'],
        district: tempdata[index]['district'],
        pincode: tempdata[index]['pincode'],
        state: tempdata[index]['state'],
        sub_perid_to_date: tempdata[index]['sub_perid_to_date'],
        taluka: tempdata[index]['taluka'],
        sub: totalTapalCount,
        parcel: `${parcelval}=${anksankhya}`,
        isSelected: false,
      });

      this.total_sub_count += totalTapalCount;
      this.totalparcel += parcelval;
      this.totalanksankhya += anksankhya;
    }

    console.log(this.groupedStates, "withoutfilter")

    this.groupedStates = this.groupedStates.filter(e => {
      return e.state == this.state;
    });

    // this.filtereddistrictwisesubcout = this.filtereddistrictwisesubcout.filter(e => {
    //   return e.district == this.district;
    // });
  } else {
    this. getStatewiseStatementList();
  }


  

  console.log(this.groupedStates, "filter")
 


  }
  uniqueid(data, key) {
    return [...new Map(data.map((x) => [key(x), x])).values()];
  }
  checkAll = false;
  masterSelected: boolean = false;

  checkUncheckAll() {
    this.selectedIds = ""
    this.checkAll = !this.checkAll;
    this.groupedStates.forEach(item => item.selected = this.checkAll);

    this.groupedStates.forEach((element: any) => {
      if (element.selected) {
        if (this.selectedIds == "") {
          this.selectedIds = element.id
        } else {
          this.selectedIds = this.selectedIds + "," + element.id
        }
      }

    });
    // alert(this.selectedIds)
    if (this.selectedIds == "") {
      this.deleteStatewiseStatemet = true;
    } else {
      this.deleteStatewiseStatemet  = false;
    }
  }
  isAllSelected() {
    this.selectedIds = ""
    this.masterSelected = this.groupedStates.every(item => item.selected);
    this.groupedStates.forEach((element: any) => {
      if (element.selected) {
        if (this.selectedIds == "") {
          this.selectedIds = element.id
        } else {
          this.selectedIds = this.selectedIds + "," + element.id
        }
      }

    });
    if (this.selectedIds == "") {
      this. deleteStatewiseStatemet = true;
    } else {
      this.deleteStatewiseStatemet = false;
    }
    // alert(this.selectedIds)
  }
  
 
 
  saveSubscriptionBarcodesDataEntry() {
    console.log(this.groupedStates);
    const filteredData = this.groupedStates.map((item) => ({
      issue_date: this.convertDateFormat(this.sundayankDate),
      country:"INDIA",
      state: item.state,
     number_of_subscribers: item.count,
     district: item.district, 
      total: this.totalcount,
      added_by: 1,
      publish_date: this.convertDateFormat(this.dispatchankDate),
      delivery_mode: this.delivery_mode,

      dispatch_date: this.convertDateFormat(this.dispatchankDate),

   
    }));
    this.groupedStates=[]

    console.log(filteredData);
    this.service.saveStatewiseStatement(filteredData).subscribe((data) => {
      alert('statewise Statements Save Successfully!');
    });
  }

  convertDateFormat(dateStr: string): string {
    const [day, month, year] = dateStr.split('/');
    return `${year}/${month}/${day}`;
  }
  
  groupDataByState(data: any[]) {
    // Use reduce to group by state and calculate the count
    const groupedData = data.reduce((acc, item) => {
      // Check if the state already exists in the accumulator
      if (!acc[item.state]) {
        acc[item.state] = 0; // Initialize with 0 if not present
      }
      acc[item.state] += 1; // Increment the count for the state
      return acc;
    }, {}); // Start with an empty object
  
    // Convert the result into an array of objects
    return Object.keys(groupedData).map(state => ({
      state: state,
      count: groupedData[state]
    }));
   

    

  }
  
  getStatewiseStatementList() {
    const request = {
      issue_date: this.issuedate,
      country:"भारत",
     // districts:this.district,
      //state:this.state
    }
    this.service. getStatewiseStatementList(request).subscribe((data: any) => {
      this.groupedStates = data.data
    });
  }
  deleteStatewiseStatementList() {
    const request = {
      ids: this.selectedIds
    }
    this.service.deleteStatewiseStatement(request).subscribe((data: any) => {
      this. deleteStatewiseStatementList();
      console.log("Deleted Successfully !!")
      //alert('statewise Statements Save Successfully!');
    });
  }
 

  
 
  
  

 

}
